import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./TeamCenterCyberSecurity.css";
import TeamCenterCyberSecurityOverview from "./TeamCenterCyberSecurityOverview";
import BannerImage from "../../../assets/other_image/5ff4673d5a.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const TeamCenterCyberSecurity = () => {
 

  return (
    <>
      <Helmet>
  <title>Teamcenter Cybersecurity Solutions in Pune | NexTech PLM</title>
  <meta
    name="description"
    content="Ensure the safety of your PLM data with Nextech’s Teamcenter Cyber Security services in Pune and across India. Protect your systems with advanced security solutions tailored for your business."
  />
  <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
</Helmet>

    <section className="TeamCenterCyberSecurity-management">
      
      
        <Banner
        image={BannerImage} // Pass the image for this page
        heading="Teamcenter Cyber Security" // Pass the heading text for this page
      />
      <div>
         <FloatingContactUs />
      </div>


      <TeamCenterCyberSecurityOverview />
      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="TeamCenterCyberSecurity-page-heading">
            Unlock the Power:
          </h4>
          <h5 className="TeamCenterCyberSecurity-subheading">
            Discover the Transformative Benefits of TeamCenter Cyber Security with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
              Stringent security for intellectual property in accordance with
              company security policies{" "}
            </li>
            <li>
              Adherence to regulatory and industry compliances includes
              import/export (ITAR, EAR, ECCN, USML), GDPR, and others{" "}
            </li>
          </ul>
        </div>
      </section>

      <section>
        <div className="solutions container">
          <div className="solutions-content">
            <div className="row">
              <div className="col-md-6 col-12">
                <h4 className="TeamCenterCyberSecurity-page-heading">Teamcenter Solutions</h4>
                <ul className="custom-bullets">
                  <li>Access Management</li>
                  <li>Security Project Management</li>
                  <li>Authorized Data Access (ADA)</li>
                  <li>Digital Rights Management (DRM)</li>
                  <li>Audit Management</li>
                  <li>Security Logging, and Monitoring</li>
                  <li>SSO (Single sign-on)</li>
                  <li>SSL (Secure Sockets Layer)</li>
                </ul>
              </div>
              <div className="col-md-6 col-12">
                <div className="quick-links">
                  <h4>Quick Links</h4>
                  <ul>
                    <li>
                      <NavLink to={"/teamcenter/cloud-implementation"}>
                        Teamcenter Implementation on Cloud
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/implementation"}>
                        Teamcenter Implementation
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/cae-integration"}>
                        Teamcenter Integration for CAE
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/cam-integration"}>
                        Teamcenter Integration for CAM
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/performance-tuning-health-checkup"}>
                        Teamcenter Performance Tuning & Health Check-up
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/program-project-management"}>
                        Teamcenter Project Management
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/rac-to-aw-client-transition"}>
                        Teamcenter RAC to Active Workspace Client Transition
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/upgrade-migration"}>
                        Teamcenter Upgrade & Migration
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="TeamCenterCyberSecurity-page-heading">Why NexTech?</h4>
          <h5 className="TeamCenterCyberSecurity-subheading">
            For Cyber Security Solution
          </h5>
          <ul className="custom-bullets">
            <li>
              Implementation of stringent security measures tailored to
              safeguard intellectual property in alignment with company security
              policies, ensuring data integrity and confidentiality.
            </li>
            <li>
              Comprehensive adherence to regulatory and industry compliance
              standards, including import/export regulations (ITAR, EAR, ECCN,
              USML) and GDPR, minimizing legal risks and liabilities.
            </li>
            <li>
              Specialized services encompassing access management, security
              project management, authorized data access (ADA), digital rights
              management (DRM), audit management, and security logging and
              monitoring.
            </li>
            <li>
              Expertise in Single Sign-On (SSO) and Secure Sockets Layer (SSL)
              protocols, enhancing user authentication and data encryption to
              prevent unauthorized access and data breaches.
            </li>
            <li>
              Proficiency in DRM technology and processes, employing encryption,
              access controls, and usage restrictions to protect and control
              digital content and intellectual property rights, ensuring
              compliance with legal and contractual terms.
            </li>
          </ul>
        </div>
      </section>
      <Letsgetintouch />
    </section>
</>
  );
};

export default TeamCenterCyberSecurity;
